import { Dialog, Box, Typography, DialogActions } from '@mui/material';
import { ReactElement, useState } from 'react';
import { connect } from 'react-redux';
import { UserSettingService } from 'services/UserSettingService';
import {
    AppPrimaryButtonOutlined,
    AppPrimaryButton,
} from 'shared/components/AppComponents';
import { Utils } from 'shared/helpers';
import { ProfileActions } from 'state/profile/Action';

const TwoFactorResetDialog = (props: any): ReactElement => {
    const { showForm, onCloseForm, profileState, update2FAStatus } = props;
    const [loader, setLoader] = useState(false);

    // API Calls
    const resetTwoFA = (callback: any): void => {
        setLoader(true);
        UserSettingService.resetTwoFactor()
            .then((response: any) => {
                Utils.handleSuccessResponse(response);
                setLoader(false);
                callback(true);
            })
            .catch((error: any) => {
                Utils.handleErrorResponse(error);
                setLoader(false);
                callback(false);
            });
    };

    // UI Actions
    const actionResetTwoFA = (): void => {
        resetTwoFA((status: any) => {
            if (status) {
                profileState.userInfo.twoFactorAuthentication.enabled = false;
                profileState.userInfo.twoFactorAuthentication.setupCompleted =
                    false;
                update2FAStatus(profileState);
                onCloseForm();
            }
        });
    };

    // UI Elements
    return (
        <Dialog
            fullWidth
            maxWidth="sm"
            open={showForm}
            className="twofactor-wrapper "
        >
            {' '}
            <Box className="pt-5 px-5">
                <Typography
                    variant="h3"
                    className="poppins-semi-bold text-primary"
                >
                    Reset 2FA
                </Typography>

                <Typography
                    variant="body1"
                    className="lato-regular text-secondary my-2"
                >
                    Reset your Two Factor Authentication.
                </Typography>
            </Box>
            <DialogActions className="px-6">
                <AppPrimaryButtonOutlined
                    className="btn-small mb-4"
                    title="Cancel"
                    onClick={onCloseForm}
                />
                <AppPrimaryButton
                    className="btn-small mb-4"
                    title="Reset"
                    onClick={actionResetTwoFA}
                    isLoading={loader}
                    loadingSize={22}
                    loadingText="RESETTING"
                />
            </DialogActions>
        </Dialog>
    );
};

const mapStateToProps = (state: any): any => ({
    profileState: state.profileState,
});

const mapDispatchToProps = (dispatch: any): any => ({
    update2FAStatus: (data: any) =>
        dispatch(ProfileActions.update2FAStatus(data)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TwoFactorResetDialog);
